export const loggingMiddleware = (action, state, additionalData) => {
  //console.log("loggingMiddleware", action);
};

export const afterLoggingMiddleware = (action, state, additionalData) => {
  // this si where we can add additional logic after the action has been dispatched
  // store the state in firebase but look at the state and action to determine what to store
  //console.log("afterLoggingMiddleware", action);
};
